import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const BackButton = ({ onClick }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(-1); // go back one step in router history
    }
  };

  return (
    <button
      onClick={handleClick}
      className="flex items-center justify-center w-10 h-10"
      style={{
        backgroundColor: '#9155FD',
        color: '#FFFFFF',
        borderRadius: '50%',
        border: 'none',
        cursor: 'pointer',
      }}
    >
      <FontAwesomeIcon icon={faArrowLeft} />
    </button>
  );
};

export default BackButton;
